import axios from 'axios';
import { API_URL } from '../../store/api/api.const';

export const getProducts = async (postcode: string, is_rural_delivery: boolean) => {
  try {
    const res = await axios.get(`${API_URL}/product/`, {
      params: {
        postcode,
        oneoff: true,
        is_rural_delivery
      },
    });
    return res.data;
  } catch (error) {
    console.error(error);
    alert('Something went wrong. Please try again later');
    throw Error();
  }
};

export const getExclusions = async () => {
  try {
    const res = await axios.get(`${API_URL}/product/exclusions/`);
    return res.data;
  } catch (error) {
    console.error(error);
    alert('Something went wrong. Please try again later');
    throw Error();
  }
};
